import { QueryKey, useQueryClient, InfiniteData } from "@tanstack/react-query";

import { PaginatedResponseModel } from "./use-list-query";

export const DEFAULT_LIST_LIMIT = 50;

interface Item {
  id: string;
}

export default function useUpdateListQuery(queryKey: QueryKey) {
  const queryClient = useQueryClient();

  return function <T extends Item>(item: T) {
    const existentQueries = queryClient.getQueriesData(queryKey);
    for (const [key] of existentQueries) {
      queryClient.setQueryData<InfiniteData<PaginatedResponseModel<T>>>(
        key,
        (oldItems) => {
          if (oldItems?.pages) {
            oldItems.pages = oldItems?.pages.map((page) => {
              if (page.data) {
                page.data = page.data.map((pageItem) => {
                  if (pageItem.id === item.id) {
                    return item;
                  }

                  return pageItem;
                });
              }

              return page;
            });
          }
          return oldItems;
        },
      );
    }
  };
}
